import logo from "../images/murdle-logo.png";

const Logo = () => {
  return <img className={"App-logo"} src={logo} alt="Maximal(Murdle)" />;
};

export default Logo;
